module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/title-result@2x-70f8f6451c5734829a8b93f75286c138.png";